import { setConfigStateById } from '../ConfigContext';

export const setShowDevelopOptionsPanel = (setState: setConfigStateById) => (showDevelopOptionsPanel) => {
  setState('SET_SHOW_DEVELOP_OPTIONS_PANEL', (s) => ({
    ...s,
    showDevelopOptionsPanel,
  }));
};
